export interface IData {
	id: number
	title: string
	slug: string
	content?: string
}

export interface Paginate {
	total: number
	per_page: number
	current_page: number
	last_page: number
	next?: any
	prev?: any
}

export interface IFooter {
	data: IData[]
	paginate: Paginate
}

export const initialFooterData: IFooter = {
	data: [
		{
			id: 1,
			title: "Chính sách bảo mật",
			slug: "chinh-sach-bao-mat",
		},
	],
	paginate: {
		total: 1,
		per_page: 6,
		current_page: 1,
		last_page: 1,
		next: null,
		prev: null,
	},
}
export const initialFooterData2: IData = {
	id: 1,
	title: "Chính sách bảo mật",
	slug: "chinh-sach-bao-mat",
	content: "Chính sách bảo mật của website",
}
